import z from 'zod';
export const stockMovementsExportSchema = z
    .object({
    startDate: z.coerce.date({ message: 'La date de début est requise' }),
    endDate: z.coerce.date({ message: 'La date de fin est requise' }),
})
    .refine((range) => range.endDate >= range.startDate, {
    message: 'La date de fin doit être postérieure à la date de début',
    path: ['endDate'],
});
